import PaymentInput from './PaymentInput';

export default PaymentInput;
